import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaClock, FaHeart, FaRegHeart, FaStar } from "react-icons/fa";

export default function TourListCard({ tour }) {
    const [isFavorite, setIsFavorite] = useState(false);
    const fallbackImage = "/assets/img/tours/default-tour.jpg";

    // API response'una göre tour verilerini düzenle
    const tourData = {
        id: tour.id,
        name: tour.name,
        slug: tour.slug,
        image: tour.thumbnail || fallbackImage,
        duration: tour.duration || "Single Day",
        price: tour.price,
        currency: tour.currency?.symbol || "€",
        location: tour.area?.name || "Unknown Location",
        isHighlighted: tour.isHighlighted || false
    };

    return (
        <div className="col-lg-4 col-sm-6 mb-4">
            <Link 
                to={`/tours/${tourData.id}`} 
                className="tourCard -type-1 py-3 px-3 border rounded text-decoration-none d-block"
                style={{
                    border: '1px solid #e9ecef',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <div className="tourCard__header position-relative">
                    <div className="tourCard__image" style={{ aspectRatio: '28/20' }}>
                        <img 
                            src={tourData.image} 
                            alt={tourData.name}
                            className="w-100 h-100 object-fit-cover"
                            style={{ 
                                borderRadius: '12px',
                                objectFit: 'cover'
                            }}
                            onError={(e) => {
                                e.target.src = fallbackImage;
                            }}
                        />
                    </div>

                    {/* Featured Badge */}
                    {tourData.isHighlighted && (
                        <div className="position-absolute top-0 start-0 m-2">
                            <span className="badge bg-warning text-dark">
                                ⭐ Featured
                            </span>
                        </div>
                    )}
                </div>

                <div className="tourCard__content px-2 pt-3">
                    <div className="tourCard__location d-flex align-items-center text-muted mb-2">
                        <FaMapMarkerAlt className="me-2" size={14} />
                        <small>{tourData.location}</small>
                    </div>

                    <h3 className="tourCard__title mb-2" style={{ 
                        fontSize: '16px', 
                        fontWeight: '500',
                        lineHeight: '1.4',
                        color: '#2c3e50'
                    }}>
                        <span className="text-capitalize">{tourData.name.toLowerCase()}</span>
                    </h3>

                    <div 
                        className="d-flex justify-content-between align-items-center pt-3 mt-3"
                        style={{ 
                            borderTop: '1px solid #e9ecef',
                            fontSize: '13px',
                            color: '#495057'
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <FaClock className="me-2" size={14} />
                            {tourData.duration}
                        </div>

                        <div>
                            <span className="text-muted">From </span>
                            <span className="fw-bold text-primary" style={{ fontSize: '16px' }}>
                                {tourData.currency}{tourData.price}
                            </span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}
